export enum SignupStatus {
  DETAILS_ENTERED = 'details-entered',
  ACCOUNT_ACTIVATED = 'account-activated',
  PAYMENT_AND_BILLING_DETAILS_ENTERED = 'payment-and-billing-details-entered'
}

export default SignupStatus
